export default __webpack_public_path__ + "static/media/apple-iMac_m1.4e500508.jpg";